export const actionType = {
    FORM_STRUCTURE_POLLING_ENABLED: 'FORM_STRUCTURE_POLLING_ENABLED',
    FORM_STRUCTURE_POLLING_DISABLED: 'FORM_STRUCTURE_POLLING_DISABLED',
    FORM_STRUCTURE_POLLING_START: 'FORM_STRUCTURE_POLLING_START',
    FORM_STRUCTURE_POLLING_STOP: 'FORM_STRUCTURE_POLLING_STOP'
} as const;
